import React, { useEffect, useState } from "react";
import "./All_Quotes.css";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Search_Post_Modal from "../common/common_modal/search_post_modal/Search_Post_Modal";
import Quote_Img_Modal from "../common/modals/quote_img_modal/Quote_Img_Modal";
import { useDispatch, useSelector } from "react-redux";
import { SpiritualInsight } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";

const All_Quotes = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalQuoteShow, setodalQuoteShow] = useState(false);
  const [image, setImage] = useState(process.env.PUBLIC_URL + '/assets/images/home/quote-day/quotes.png');
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const dispatch = useDispatch();
  const spiritual_insights = useSelector((state) => state.common.spiritual_insights);

  useEffect(() => {
    dispatch(SpiritualInsight({ startDate, endDate }));
  }, [dispatch, endDate]);

  return (
    <section className="All_Quotes">
      <div className="container">
        <div className="top_div">
          <Common_Back_Header />

          <div
            className="search_div"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} className="inner_icon" />
            <p className="search_text">Search By</p>
          </div>
        </div>

        <div className="content_div">
          <div className="row justify-content-center">
            {spiritual_insights?.data?.length > 0 ?
              spiritual_insights.data?.map((spiritual_insight, index) => (
                <div className="col-lg-4 col-md-4 col-sm-6 mb-3" key={index}>
                  <div
                    className="quote_img_holder"
                    onClick={() => {
                      setodalQuoteShow(true);
                      setImage(IDS.IMG_URL + spiritual_insight?.image);
                    }}
                  >
                    <img
                      src={IDS.IMG_URL + spiritual_insight?.image}
                      className="quote_img"
                      alt=""
                    />
                  </div>
                </div>
              ))
              : <>
                <div className="col-lg-4 col-md-4 col-sm-6 mb-3">
                  <div>
                    No Post Found
                  </div>
                </div>
              </>
            }

          </div>
        </div>
      </div>

      <Search_Post_Modal
        show={showModal}
        setEndDate={setEndDate}
        setStartDate={setStartDate}
        onHide={() => {
          setShowModal(false);
        }}
      />

      <Quote_Img_Modal image={image} show={modalQuoteShow} onHide={() => setodalQuoteShow(false)} />
    </section>
  );
};

export default All_Quotes;
